module.exports = __webpack_public_path__ + "demo-game.ab90fcf.jpeg";